<script>
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import { tweened } from "svelte/motion"
  import Deudas from "../components/empresa/Deudas.svelte"
  import General from "../components/empresa/General.svelte"
  import Historico from "../components/empresa/Historico.svelte"
  import Planilla from "../components/empresa/Planilla.svelte"
  import Footer from "../components/Footer.svelte"
  import Header from "../components/Header.svelte"
  import Spinner from "../components/Spinner.svelte"
  import { verifySession } from "../services/verifySession"
  import { BASE_URL } from "../stores/BASE_URL"
  import { user } from "../stores/User"
  import Sidebar from "../components/Sidebar.svelte"

  export let ruc

  let razon_social = ""

  let estadoInicial = 0
  let loading = true
  const planesSinHistoricoDeudas = [
    "Bronze I",
    "Bronze II",
    "Silver I",
    "Ilimitado I",
  ]

  $: mostrarHistoricoDeudas =
    $user && !planesSinHistoricoDeudas.includes(($user.plan || "").trim())

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    } else {
      verifySession($user.session_key)
      let consultas = $user.consultas - $user.consumo
      if (consultas > 0) {
        registrar()
      } else {
        navigate("/inicio", { replace: true })
      }
      if (!$user.permisos.includes("empresa")) {
        user.setUser(null)
        navigate("/", { replace: true })
      }

      //Pass
      if ($user.actualizar_clave == "1") {
        navigate("/seguridad", { replace: true })
      }

      //C
      if ($user.verificar == "1") {
        navigate("/verificar", { replace: true })
      }
    }
  })

  const registrar = async () => {
    let formData = new FormData()
    formData.append("documento", ruc)
    formData.append("tipo", "empresa")
    formData.append("session_key", $user.session_key)

    const response = await fetch(`${BASE_URL}consulta.php`, {
      method: "POST",
      body: formData,
    })

    const resp = await response.json()
    razon_social = resp.data.razon_social

    if (resp.status == "error") {
      user.setUser(null)
      navigate("/", { replace: true })
    }

    loading = false
    getPuntos()
  }

  $: {
    actualizarPagina(ruc)
  }

  const actualizarPagina = (doc) => {
    if (estadoInicial > 0) {
      document.location.reload()
    }
    estadoInicial++
  }

  const getPuntos = async () => {
    const response = await fetch(
      `${BASE_URL}session.php?session_key=${$user.session_key}`,
    )
    const resp = await response.json()

    if (resp.status === "success") {
      let temp_user = $user
      temp_user.consumo = resp.data.consumo
      temp_user.consultas = resp.data.consultas
      temp_user.inicio = resp.data.inicio
      temp_user.fin = resp.data.fin
      user.setUser(temp_user)
    } else {
      navigate("/", { replace: true })
    }

    reiniciarTiempo()
  }

  // Tiempo de sessión
  let original = 20 * 60
  let timer = tweened(original)

  setInterval(() => {
    if ($timer > 0) $timer--
  }, 1000)

  $: minutes = Math.floor($timer / 60)

  $: if (minutes <= 0) {
    user.setUser(null)
    navigate("/", { replace: true })
  }

  const reiniciarTiempo = () => {
    timer = tweened(original)
  }
</script>

{#if $user}
  <main class="d-flex flex-column md:flex-row page-shell">
    <Sidebar />

    <div class="d-flex flex-column flex-grow-1 page-content">
      <Header />
      {#if loading}
        <div class="p-5">
          <Spinner />
        </div>
      {:else}
        <div class="container-fluid py-5 bg-2">
          <div class="d-flex flex-wrap align-items-center gap-3 border-bottom">
            <ul class="nav nav-tabs border-0" id="pills-tab-e" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="pills-general-tab-e"
                  data-bs-toggle="tab"
                  data-bs-target="#pills-general-e"
                  type="button"
                  role="tab"
                  aria-controls="pills-general-e"
                  aria-selected="true"
                  ><i class="bi bi-building me-1"></i> Información General</button
                >
              </li>
              {#if mostrarHistoricoDeudas}
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="pills-historico-tab-e"
                    data-bs-toggle="tab"
                    data-bs-target="#pills-historico-e"
                    type="button"
                    role="tab"
                    aria-controls="pills-historico-e"
                    aria-selected="false"
                  >
                    <i class="bi bi-calendar2-check me-1"></i> Histórico</button
                  >
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="pills-deudas-tab-e"
                    data-bs-toggle="tab"
                    data-bs-target="#pills-deudas-e"
                    type="button"
                    role="tab"
                    aria-controls="pills-deudas-e"
                    aria-selected="false"
                  >
                    <i class="bi-graph-up-arrow me-1"></i> Deudas
                  </button>
                </li>
              {/if}
              <!-- {#if $user.permisos.includes("planilla1") || $user.permisos.includes("planilla2")} -->
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-planilla-tab-e"
                  data-bs-toggle="tab"
                  data-bs-target="#pills-planilla-e"
                  type="button"
                  role="tab"
                  aria-controls="pills-planilla-e"
                  aria-selected="false"
                >
                  <i class="bi bi-file-earmark-medical me-1"></i> Planilla</button
                >
              </li>
              <!-- {/if} -->
            </ul>
            <p class="empresa-summary small my-1 ms-auto text-end">
              {ruc}
              <span class="fg-secondary"> - </span>
              {razon_social}
            </p>
          </div>
          <div class="tab-content" id="pills-tabContent-e">
            <div
              class="tab-pane fade show active"
              id="pills-general-e"
              role="tabpanel"
              aria-labelledby="pills-general-tab-e"
            >
              <General {ruc} />
            </div>
            {#if mostrarHistoricoDeudas}
              <div
                class="tab-pane fade"
                id="pills-historico-e"
                role="tabpanel"
                aria-labelledby="pills-historico-tab-e"
              >
                <Historico {ruc} />
              </div>
              <div
                class="tab-pane fade"
                id="pills-deudas-e"
                role="tabpanel"
                aria-labelledby="pills-deudas-tab-e"
              >
                <Deudas {ruc} />
              </div>
            {/if}
            <div
              class="tab-pane fade"
              id="pills-planilla-e"
              role="tabpanel"
              aria-labelledby="pills-planilla-tab-e"
            >
              <Planilla {ruc} />
            </div>
          </div>
        </div>
      {/if}
      <Footer />
    </div>
  </main>
{/if}

<style>
  .empresa-summary {
    flex: 1 1 18rem;
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .page-shell {
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
  }

  .page-content {
    min-width: 0;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }

  @media (max-width: 767.98px) {
    .page-shell {
      height: auto;
      min-height: 100vh;
      overflow: visible;
    }

    .page-content {
      overflow: visible;
    }
  }
</style>
